import { useCallback, useState } from 'react'

export const usePurchaseBlockedModal = () => {
  const defaultPurchaseBlockedModalData = {
    period: 0,
    state: ''
  }

  const [showPurchaseBlockedModal, setShowPurchaseBlockedModal] = useState(false)
  const [purchaseBlockedModalData, setPurchaseBlockedModalData] = useState(defaultPurchaseBlockedModalData)

  const openPurchaseBlockedModal = useCallback(data => {
    setShowPurchaseBlockedModal(true)
    setPurchaseBlockedModalData(data)
  }, [])

  const closePurchaseBlockedModal = useCallback(() => {
    setShowPurchaseBlockedModal(false)
    setPurchaseBlockedModalData(defaultPurchaseBlockedModalData)
  }, [])

  return { showPurchaseBlockedModal, closePurchaseBlockedModal, openPurchaseBlockedModal, purchaseBlockedModalData }
}
